import mongoose from "mongoose";

export enum SDMStatus {
  pending = 0,
  uploading = 1,
  invalid = 2,
  valid = 3,
}

export interface SDMDocument {
  _id: mongoose.Schema.Types.ObjectId;
  userId?: string;
  fileName: string;
  contentType: string;
  shared: boolean;
  customerId?: string;
  status: SDMStatus;
  saved: boolean;
  createdAt: Date;
  meta?: unknown;
}

export const SDMDocumentSchema = new mongoose.Schema<SDMDocument>({
  userId: { type: String, index: true },
  fileName: String,
  contentType: String,
  shared: { type: Boolean, default: false },
  customerId: { type: String, index: true },
  status: { type: Number, default: 0 },
  saved: { type: Boolean, default: false },
  createdAt: { type: Date, default: Date.now },
  meta: mongoose.Schema.Types.Mixed,
});
